<template>
    <div class="exchangeDetails flexC">
        <div class="details-container" :class="{'finish-container':detail.userReward&&detail.userReward.finished == 1}">
            <p class="title">活动信息</p>
            <div class="info-container">
                <div class="info-item flexC">
                    <span class="label">活动名称：</span>
                    <span class="value">{{detail.name||'--'}}</span>
                </div>
                <div class="info-item flexC">
                    <span class="label">姓 名：</span>
                    <span class="value">{{detail.userName||'--'}}</span>
                </div>
                <div class="info-item flexC">
                    <span class="label">联系方式：</span>
                    <span class="value">{{detail.userTel||'--'}}</span>
                </div>
            </div>
            <div class="ewm-container">
                <div class="ewm-head flexC">
                    <p class="time">
                        活动日期：{{detail.startDt}}至{{detail.endDt}}
                    </p>
                    <p class="flexC desc" v-if="detail.userReward">
                        <img src="@/assets/img/gift-icon.png" alt="">
                        <span class="txt">已达到V{{detail.userReward.promotionLevel}}:{{detail.userReward.reward}}</span>
                    </p>
                </div>
                <div class="qrcode-container flexC">
                    <div id="qrcode" class="qrcode" ref="qrcode"></div>
                    <p class="desc">请凭此二维码兑换礼品</p>
                </div>
            </div>
            <p class="address flexC" v-if="detail.tenantAdress">
                <span class="label">
                    门店地址：
                </span>
                <span class="value">
                    {{detail.tenantAdress}}
                </span>
            </p>
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { promotionGet } from "@/api/promotion";
export default {
    data () {
        return {
            detail:{}
        }
    },
    created () {
        document.title = "兑换详情";
        this.getActivityData()
    },
    methods: {
        getActivityData(){
            promotionGet({id:this.$route.query.id}).then(result =>{
                if(result.data.errorCode == 0){
                    this.detail = result.data.data;
                    document.getElementById("qrcode").innerHTML = "";
                    this.$nextTick(()=>{
                        new QRCode("qrcode", {
                            width: 250,
                            height: 250,
                            text: JSON.stringify(this.detail.promotionQrJson)
                        })
                    })
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.exchangeDetails{
    flex-direction: column;
    background: #F5F6FA;
    .details-container{
        flex: 1;
        width: 100%;
        background: #fff;
        margin-top: 0.4rem;
        padding: 0.6rem;
        box-sizing: border-box;
        .title{
            position: relative;
            font-size: 0.72rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            padding-left: 0.6rem;
            margin:0.1rem 0;
            &::after{
                background: #3E8EFA;
                border-radius: 0.12rem;
                position: absolute;
                left: 0;
                width: 0.16rem;
                height: 0.72rem;
                content: " ";
                top: 50%;
                transform: translate(0,-50%);
            }
        }
        .info-container{
            .info-item{
                font-size: 0.64rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 0.9rem;
                align-items: flex-start;
                margin: 0.36rem 0;
                .label{
                    width: 4rem;
                    text-align: right;
                    flex: 0 0 auto;
                }
                .value{
                    flex: 1;
                }
            }
        }
        .ewm-container{
            margin: 0.4rem 1.1rem;
            box-shadow: 0 0.08rem 0.2rem 0 rgba(185,185,185,0.5);
            border-radius: 0.4rem;
            .ewm-head{
                flex-direction: column;
                background: linear-gradient(360deg, #F56C6C 0%, #FAB6B6 100%);
                border-radius: 0.4rem 0.4rem 0 0;
                height: 3.36rem;
                justify-content: center;
                .time{
                    font-size: 0.52rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 0.74rem;
                    margin-bottom: 0.2rem;
                }
                .desc{
                    img{
                        width: 1.4rem;
                        height: auto;
                    }
                    .txt{
                        font-size: 0.72rem;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #FFFFFF;
                        line-height: 1rem;
                        letter-spacing: 0.06rem;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
        .qrcode-container{
            flex-direction: column;
            padding: 0.7rem;
            justify-content: center;
            .qrcode{
                padding: 0.1rem;
                width: 5rem;
                height: 5rem;
                /deep/ canvas{
                    width: 100%;
                    height: 100%;
                }
                /deep/ img{
                    width: 100%;
                    height: 100%;
                }
            }
            .desc{
                font-size: 0.52rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 0.74rem;
                margin-top: 0.32rem;
            }
        }
        .address{
            font-size: 0.52rem;
            justify-content: center;
            align-items: flex-start;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 0.74rem;
            margin-top: 0.6rem;
            .label{
                flex: 0 0 auto;
            }
        }
    }
    .finish-container{
        position: relative;
        &::after{
            position: absolute;
            content: " ";
            width: 3.4rem;
            height: 2.8rem;
            top: 0.8rem;
            right: 1rem;
            background: url("~@/assets/img/used-icon.png") no-repeat;
            background-size: auto 100%;
        }
    }
}
</style>